import React, {useState} from 'react'
import {Button, Modal} from "antd";
import {deleteProductionCost} from "../../services/serviceProductionCost";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const ProductionCostDelete = ({costId, updater}) => {

    const [deleteModal, setDeleteModal] = useState(false)
    const [loadings, setLoadings] = useState([])


    const handleDeleteClick = (decision) => {
        if (decision) {
            enterLoadingState(setLoadings)
            deleteProductionCost(costId)
                .then(() => {
                    exitLoadingState(setLoadings)
                    setDeleteModal(!deleteModal)
                    updater()
                })
                .catch(() => exitLoadingState(setLoadings))
        } else {
            setDeleteModal(!deleteModal)
        }
    }

    return (
        <React.Fragment>
            <Button type={'link'} danger onClick={() => setDeleteModal(!deleteModal)}>Sil</Button>

            <Modal
                open={deleteModal}
                closable={false}
                title={'Silmek istediğinize emin misiniz ?'}
                footer={[
                    <Button danger type={'primary'} key={'SubmitButton'}
                            loading={loadings[0]}
                            onClick={() => handleDeleteClick(true)}>Onayla</Button>,
                    <Button key={'CancelButton'} onClick={() => handleDeleteClick(false)}>Vazgeç</Button>
                ]}
            >

            </Modal>
        </React.Fragment>
    )
}
export default ProductionCostDelete